/* eslint object-curly-newline: 'off' */

export const assembly = [
  { name: 'topsilkscreen', offset: 0.9 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'drills', offset: -0.8 },
  { name: 'holes', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottomsilkscreen', offset: -1.0 },
];

export const layoutReal = [
  { name: 'topsilkscreen', offset: 0.9 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'drills', offset: -0.8 },
  { name: 'holes', offset: -0.8 },
  { name: 'millinglv1', offset: -0.8 },
  { name: 'millinglv2', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottomsilkscreen', offset: -1.0 },
];

export const layoutRealStencil = [
  { name: 'toppaste', offset: 1.0 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottompaste', offset: -1.0 },
];

export const layout8Layer = [
  { name: 'toplayer', offset: 0.4 },
  { name: 'internalplane1', offset: 0.3 },
  { name: 'internalplane2', offset: 0.2 },
  { name: 'boardoutline', offset: 0.0 },
  { name: 'internalplane3', offset: -0.2 },
  { name: 'internalplane4', offset: -0.3 },
  { name: 'internalplane5', offset: -0.4 },
  { name: 'internalplane6', offset: -0.5 },
  { name: 'bottomlayer', offset: -0.6 },
  { name: 'drills', offset: -0.7 },
  { name: 'holes', offset: -0.7 },
];

export const layout6Layer = [
  { name: 'toplayer', offset: 0.4 },
  { name: 'internalplane1', offset: 0.3 },
  { name: 'internalplane2', offset: 0.2 },
  { name: 'boardoutline', offset: 0.0 },
  { name: 'internalplane3', offset: -0.2 },
  { name: 'internalplane4', offset: -0.3 },
  { name: 'bottomlayer', offset: -0.4 },
  { name: 'drills', offset: -0.5 },
  { name: 'holes', offset: -0.5 },
];

export const layout4Layer = [
  { name: 'toplayer', offset: 0.4 },
  { name: 'internalplane1', offset: 0.1 },
  { name: 'boardoutline', offset: 0 },
  { name: 'drills', offset: -0.4 },
  { name: 'holes', offset: -0.4 },
  { name: 'internalplane2', offset: -0.1 },
  { name: 'bottomlayer', offset: -0.2 },
];

export const layout2Layer = [
  { name: 'toplayer', offset: 0.4 },
  { name: 'boardoutline', offset: 0 },
  { name: 'drills', offset: -0.4 },
  { name: 'holes', offset: -0.4 },
  { name: 'bottomlayer', offset: -0.2 },
];
